"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class KeyValueDB {
  static get(key) {
    return KeyValueDB.db.get(key);
  }
  static set(key, value) {
    KeyValueDB.db.set(key, value);
  }
  static delete(key) {
    KeyValueDB.db.delete(key);
  }
  static clear() {
    KeyValueDB.db.clear();
  }
  static has(key) {
    return KeyValueDB.db.has(key);
  }
  static keys() {
    return KeyValueDB.db.keys();
  }
  static values() {
    return KeyValueDB.db.values();
  }
  static size() {
    return KeyValueDB.db.size;
  }
  static forEach(callback) {
    KeyValueDB.db.forEach(callback);
  }
}
KeyValueDB.db = new Map();
var _default = exports.default = KeyValueDB;